import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import agreement from './agreement/reducer';
import analytic from './analytic/reducer';
import auth from './auth/reducer';
import config from './config/reducer';
import contacts from './contacts/reducer';
import contactsByCpf from './contactsByCpf/reducer'
import contract from './contract/reducer';
import error from './error/reducer';
import negotiation from './negotiation/reducer';
import proposal from './proposal/reducer';
import validate from './validate/reducer';
import addresses from './addresses/reducer';

/**
 * Definição dos tipos usados no Typesafe-Actions.
 * Adicionar novos tipos no ActionsUnion.
 * Exemplo: typeof import('./contacts/actions') | typeof import('./novoDuck/actions');
 */
type ActionsUnion =
  | typeof import('./contacts/actions')
  | typeof import('./contactsByCpf/actions')
  | typeof import('./auth/actions')
  | typeof import('./contract/actions')
  | typeof import('./proposal/actions')
  | typeof import('./agreement/actions')
  | typeof import('./analytic/actions')
  | typeof import('./negotiation/actions')
  | typeof import('./error/actions')
  | typeof import('./addresses/actions');
declare type RootAction = ActionType<ActionsUnion>;
declare module 'typesafe-actions' {
  interface Types {
    RootAction: RootAction;
  }
}

export default combineReducers<ApplicationState>({
  config,
  validate,
  auth,
  contacts,
  contactsByCpf,
  contract,
  proposal,
  agreement,
  analytic,
  negotiation,
  error,
  addresses
});
